import { render, staticRenderFns } from "./processDetail.vue?vue&type=template&id=7cb5c003&scoped=true"
import script from "./processDetail.vue?vue&type=script&lang=js"
export * from "./processDetail.vue?vue&type=script&lang=js"
import style0 from "./processDetail.vue?vue&type=style&index=0&id=7cb5c003&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb5c003",
  null
  
)

export default component.exports